export default __webpack_public_path__ + "static/media/TransportIcon.76d6be30.svg";